import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { HeroBannerImageContainingTextTileModel } from '@/types/B2CcontentServerContract';
import HeroBannerImageContainingTextTileContent
    from '@/shared/content/blocks/helpers/HeroBannerImageContainingTextTileContent.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroBannerImageContainingTextTile',
  props: {
    content: null,
    parent: null
  },
  setup(__props: any) {

const props = __props as {
    content: HeroBannerImageContainingTextTileModel,
    parent: string,
}



const imageAspectRatio = computed<number | object>(() => {
    const isSimpleHeroBanner = props.parent === 'HeroBannerSimpleBlocksTile';
    return isSimpleHeroBanner ? 4 : 3;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HeroBannerImageContainingTextTileContent, {
    content: __props.content,
    "image-aspect-ratio": _unref(imageAspectRatio)
  }, null, 8, ["content", "image-aspect-ratio"]))
}
}

})